import { useCallback, useEffect, useState } from "react";
import useAlert from "../Components/Alerts/useAlert";
import { fetchDataAuthenticated } from '../utilities/HttpUtils'

export const useSites = () => {
    const { setAlert } = useAlert();
    const [sites, setSites] = useState([]);
    const [loading, setLoading] = useState(true);

    const _apiUrl = window.runtimeConfig.WEBSITE_BACKEND_URI;

    const getSites = useCallback(() => {
        setLoading(true);
        fetchDataAuthenticated(_apiUrl + "/siteDetails")
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error("Failed to get sites");
            })
            .then(data => {
                setSites(data);
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [fetchDataAuthenticated, setAlert, _apiUrl]);

    useEffect(() => {
        getSites();
    }, [getSites]);

    return { loading, sites, getSites };
};